import { z } from "zod";

export const vehicleSchema = z.object({
  methodId: z.number().nullable().default(null),
  cardCount: z.number().or(z.string()).nullable().default(null),
  cards: z.array(z.object({ id: z.number() })).default([]),
  id: z.number(),
});
